import Hero from './Hero'
import './hero.module.scss'

export default Hero
